// removed by extract-text-webpack-plugin
module.exports = {"content":"index__content___1tCaL","show":"index__show___27iWO","hide-header-footer":"index__hide-header-footer___28xpb","hideHeaderFooter":"index__hide-header-footer___28xpb","cookie":"index__cookie___2jgnO","alert":"index__alert___3Yd94"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/App/index.css
// module id = 1022
// module chunks = 37